<script setup>
import { useNavegacaoStore } from "@/stores/navegacao";
import Button from "primevue/button";

const props = defineProps({
    buttonStyle: {
        type: Object,
        default: () => ({})
    },
    iconStyle: {
        type: Object,
        default: () => ({})
    },
    buttonHoverColor: {
        type: String,
        default: 'var(--p-button-text-primary-hover-background)'
    },
});

const { goBack } = useNavegacaoStore();
</script>

<template>
    <Button
        title="Voltar"
        icon="pi pi-chevron-left"
        size="large"
        rounded
        text
        pt:root:class="secondary-button-root"
        :pt:root:style="props.buttonStyle"
        :pt:icon:style="props.iconStyle"
        :style="{
            '--p-button-text-primary-hover-background': props.buttonHoverColor
        }"
        @click="goBack()"
    />
</template>

<style scoped>

</style>
